import {observable} from 'mobx';
import {
  TYPE_DIAMOND_COLORLESS,
  TYPE_DIAMOND_FANCY,
  TYPE_JEWELRY,
  TYPE_LGD_COLORLESS, TYPE_LGD_FANCY, TYPE_LGD_ROUGH, TYPE_ROUGH,
} from '../../product/constants/productTypes';

const PRODUCT_SORT_TYPES_MAP = {
  [TYPE_DIAMOND_COLORLESS]: TYPE_DIAMOND_COLORLESS,
  [TYPE_DIAMOND_FANCY]: TYPE_DIAMOND_FANCY,
  [TYPE_JEWELRY]: TYPE_JEWELRY,
  [TYPE_LGD_COLORLESS]: TYPE_LGD_COLORLESS,
  [TYPE_LGD_FANCY]: TYPE_LGD_FANCY,
  [TYPE_ROUGH]: TYPE_ROUGH,
  [TYPE_LGD_ROUGH]: TYPE_ROUGH,
};

export default class SortRepository {
  /**
   * @type {[Object.<string, [Sort]>]}
   */
  @observable
  sortsByType;

  /**
   * @private
   * @param {Object} productTypeSpecificConstants
   * @param {[Object]} sortsData
   * @return {Object}
   */
  static modifyProductTypes(productTypeSpecificConstants, sortsData) {
    const result = {};
    Object.keys(PRODUCT_SORT_TYPES_MAP).forEach((productType) => {
      result[productType] = productTypeSpecificConstants[PRODUCT_SORT_TYPES_MAP[productType]].sorts
        .map(sortId => sortsData.find(sort => sort.id === sortId))
        .filter(s => Boolean(s));
    });

    return result;
  }

  /**
   * @param {[Object]} sortsData
   * @param {Object} sortsByProductType
   * @return {*}
   */
  initSorts(sortsData, sortsByProductType) {
    this.sortsByType = SortRepository.modifyProductTypes(sortsByProductType, sortsData);
  }

  /**
   * @param {string} productType
   * @return {[Sort]}
   */
  getSortsByProductType(productType) {
    return this.sortsByType[productType];
  }
}

export const sortRepository = new SortRepository();
